export function Instructions() {
  return (
    <div className="max-w-4xl mx-auto mt-3 sm:mt-2 text-center text-gray-700 italic text-sm sm:text-base px-2 sm:px-0">
      <p>Spustelėkite dieną, kad pažymėtumėte arba ištrintumėte datas, kuriomis norite suskaičiuoti darbo dienas.</p>
      <p>Paspauskite mėnesio pavadinimą, kad pereitumėte į mėnesio kalendorių.</p>
    </div>
  );
}
